import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Btn } from "@/components/erp/ui";
import { err } from "@/components/erp/flow/FlowCommon";
import { Sparkles } from "lucide-react";

export const SocialTrends = () => {
  const [rows, setRows] = useState([]); const [busy, setBusy] = useState(false);
  const load = () => api.get("/social/trends").then(({ data }) => setRows(data)).catch(err);
  useEffect(() => { load(); }, []);
  const gen = async () => { setBusy(true); try { await api.post("/social/trends"); toast.success("Referensi tren baru siap"); load(); } catch (e) { err(e); } setBusy(false); };
  const cur = rows[0];
  return (
    <div data-testid="trend-page">
      <Btn data-testid="trend-gen" disabled={busy} onClick={gen}><Sparkles className="w-4 h-4" /> {busy ? "AI sedang menyusun\u2026" : "Update referensi tren"}</Btn>
      <p className="text-[11px] text-slate-400 mt-1">Disusun Model AI di Pengaturan — berupa ide & pola tren, bukan data viral real-time. Cek ulang sebelum dipakai.</p>
      {cur && <div className="text-xs text-slate-500 mt-4">Diperbarui {cur.created_at.slice(0, 16).replace("T", " ")} oleh {cur.by}</div>}
      <div className="grid md:grid-cols-2 gap-3 mt-2">
        {(cur?.items || []).map((t, i) => (
          <div key={i} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`trend-item-${i}`}>
            <div className="text-xs text-slate-500">{t.platform} · {t.format}</div>
            <div className="font-semibold">{t.title}</div>
            <p className="text-sm mt-1">{t.idea}</p>
            {t.hook && <p className="text-xs text-amber-700 mt-1">Hook: “{t.hook}”</p>}
            <div className="text-xs text-sky-700 mt-1">{(t.hashtags || []).join(" ")}</div>
          </div>
        ))}
      </div>
      {!cur && <p className="text-sm text-slate-400 mt-3" data-testid="trend-empty">Belum ada referensi. Klik tombol di atas.</p>}
    </div>
  );
};
